import React from 'react';
import Component from './Rate';
import inputable from '../Form/inputable';
export default (function (background, front) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var Rate = inputable(function (props) {
    return (
      /*#__PURE__*/
      React.createElement(Component, Object.assign({}, opts, props, {
        background: background,
        front: front || background
      }))
    );
  });
  Rate.displayName = 'ShineoutRate';
  return Rate;
});